module.exports = __webpack_public_path__ + "assets/img/kv-f8b13c31.jpg";